export default "__VITE_ASSET__DVMvKE_M__"